import React from "react";

import Styles from "./ProfileSupport.styles";
import { ProfileSupportProps as Props } from "./ProfileSupport.types";
import Footer from "components/global/Footer/Footer";
import GoBack from "components/global/GoBack/GoBack";
import Navbar from "components/global/Navbar/Navbar";
import ProfileNavigation from "components/global/ProfileNavigation/ProfileNavigation";
import CONSTANTS from "config/constants";
import useI18n from "hooks/useI18n";

import EmailSVG from "../../../../public/assets/images/profile-email.svg";
import PhoneSVG from "../../../../public/assets/images/profile-phone.svg";
import WhatsappSVG from "../../../../public/assets/images/whatsapp.svg";

const { FEATURE_FLAGS } = CONSTANTS;
const { WITH_BOTTOM_SEARCH, WITH_BOTTOM_RESPONSIVE_BUTTONS } = FEATURE_FLAGS;

const ProfileSupport: React.FC<Props> = props => {
  const t = useI18n();

  return (
    <Styles
      className="ProfileSupport"
      withBottomSearch={WITH_BOTTOM_SEARCH}
      withBottomResponsiveButtons={WITH_BOTTOM_RESPONSIVE_BUTTONS}
    >
      <header className="ProfileSupport__header">
        <Navbar showBrand title="Contactar con soporte" />
      </header>
      <main className="ProfileSupport__main">
        <ProfileNavigation className="ProfileSupport__navigation" />
        <div className="ProfileSupport__content">
          <GoBack className="ProfileSupport__go-back" title="Atrás" />
          <div className="ProfileSupport__container">
            <div className="ProfileSupport__content__header">
              <h1 className="ProfileSupport__content__title">
                {t.profile.support.title}
              </h1>
              <p className="ProfileSupport__content__info">
                {t.profile.support.description}
              </p>
              <a
                className="ProfileSupport__contact"
                href="https://api.whatsapp.com/send?phone=593099468964"
                target="_blank"
                rel="noreferrer"
              >
                <WhatsappSVG className="ProfileSupport__whatsapp-icon" />
                <p>
                  {t.profile.support.whatsapp}: <span>+593 099468964</span>
                </p>
              </a>
              <a className="ProfileSupport__contact" href="tel:022210800">
                <PhoneSVG />
                <p>
                  {t.profile.support.phone}: <span>02-2210800</span>
                </p>
              </a>
              <a
                className="ProfileSupport__contact"
                href="mailto:servicioalcliente@sushicorp.ec"
              >
                <EmailSVG />
                <p>
                  {t.profile.support.email}:{" "}
                  <span>servicioalcliente@sushicorp.ec</span>
                </p>
              </a>
            </div>
          </div>
        </div>
      </main>
      <footer className="ProfileSupport__footer">
        <Footer />
      </footer>
    </Styles>
  );
};

ProfileSupport.defaultProps = {};

export default ProfileSupport;
